// @flow
import type { Element, Node } from 'react';

import React from 'react';
import RequireAuthorization from '#components/support/routing/RequireAuthorization/index.jsx';
import { MODELS } from '#constants/pathStrings.js';

type Props = {|
  children: Node,
  hasExtractionAccess: boolean,
  isAuthenticated: boolean,
  routeParams: {| modelId: string |},
  redirectTo?: string,
|};

const RequireExtractionPermission = ({
  children,
  hasExtractionAccess,
  isAuthenticated,
  routeParams,
  redirectTo = `/${MODELS}/${routeParams.modelId}`,
}: Props): Element<typeof RequireAuthorization> => (
  <RequireAuthorization
    isAuthorized={hasExtractionAccess && isAuthenticated}
    redirectTo={redirectTo}
  >
    {children}
  </RequireAuthorization>
);

export default RequireExtractionPermission;
